<template>
  <div id="app">
    
    <!-- <nav-bar /> -->
    <div class="container-fluid full">
      <div class="row">
        <side-bar class="col-2 p-0" style="margin-left:-15px; max-width: 275px"/>
        <div class="col-10 p-0  shadow2">
              <router-view></router-view>
        </div>
      </div>
    </div>
    <div class="container-fluid movil">
      <div class="row">
        <side-bar class="col-12 p-0" style="margin-left:-5px; "/>
        <div class="col-md-10 p-0 shadow2">
              <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "../../components/Sidebar.vue"
// import NavBar from "./components/Navbar.vue"
export default {
  components: {
    SideBar,
    // NavBar
  },
  data(){
    return{
      user: null
    }
  },
  mounted() {
    this.$store.watch(
      (state) => state.user,
      (value) => {
        this.user = value
      }
    );

    this.user = localStorage.getItem("user");
    // if (this.user) {

    //   this.$store.commit("setUser", JSON.parse(this.user));
    // }
    // const store = localStorage.getItem("store");
    // if (store) {
    //   this.$store.commit("setStore", JSON.parse(store));
    // }
  },
  methods: {
    logout() {
      localStorage.removeItem("user");
      this.$store.commit("setUser", null);
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style lang="scss">
// @import "app.scss";
.shadow2{
  border-left: 1px solid rgb(160, 160, 160);
}
</style>
